var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.47715 0 0 4.47715 0 10V0H10ZM20 10C20 4.47715 15.5228 0 10 0H20V10ZM10 20C4.47715 20 0 15.5228 0 10V20H10ZM10 20C15.5228 20 20 15.5228 20 10V20H10Z",
    fill: "#F7F9FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuEdge);
export default __webpack_public_path__ + "static/media/menu-edge.4534e48b1e39cfe706da5209cc823647.svg";
export { ForwardRef as ReactComponent };